<template>
  <div>
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="80%"
      :wrapperClosable="false"
    >
      <div class="header">
        <el-select
          v-model="TemplateId"
          placeholder="请选择模板"
          @change="changeTemplate"
          style="width: 300px"
        >
          <el-option
            v-for="item in TemplateList"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          >
          </el-option>
        </el-select>
        <el-button @click="generatePdf" type="primary" style="margin-left: 10px"
          >生成文件</el-button
        >
        <span style="font-size: 14px; color: red; margin-left: 10px"
          >注：设备卡片打印需使用专用打印机打印</span
        >
      </div>
      <div class="form-center" v-loading="loading">
        <div ref="Content" v-if="TemplateId">
          <div
            v-for="ele in rows"
            :key="ele.Id"
            class="Dom"
            :style="`width:${TemplateJson.width}cm;height:${TemplateJson.height}cm;position: relative;`"
          >
            <div
              ref="pdfContent"
              :style="`width:${TemplateJson.width}cm;height:${TemplateJson.height}cm;position: relative;`"
            >
              <!-- isActive: true, //激活状态
        isDraggable: true, //允许拖拽
        isResizable: true, //允许调整大小
        aspectRatio: false, //是否保持比例
        w: 200,
        h: 40,
        minw: 10,
        minh: 10,
        x: 0,
        y: 0,
        parentW: 0, //父级宽度
        parentH: 0, //父级高度

        parentLimitation: true, //设置为true，则限制操作组件不能超出父级元素
        preventActiveBehavior: false, //单击组件外区域来禁止组件行为 -->
              <VueDragResize
                v-for="(item, index) in TemplateJson.printlist"
                :gridX="2"
                :gridY="2"
                :key="item.Id"
                :isActive="false"
                :preventActiveBehavior="false"
                :isDraggable="false"
                :isResizable="false"
                :aspectRatio="false"
                parentLimitation
                :w="item.w"
                :h="item.h"
                :x="item.x"
                :y="item.y"
                :minh="28"
                :minw="80"
              >
                <div
                  style="width: 100%; height: 100%; display: flex"
                  v-if="item.FiledKey != 'Id'"
                >
                  <div
                    :style="`font-size:${item.title_fontSize}px;font-weight:${item.title_bold};line-height:${item.title_lineHeight}px;text-align:${item.title_align};font-family:${item.title_family};;`"
                  >
                    {{ item.FieldName }}：
                  </div>

                  <div
                    :style="`${
                      item.isline ? 'border-bottom: 1px solid #000;' : ''
                    }flex: 1;font-size:${item.fontSize}px;font-weight:${
                      item.bold
                    };line-height:${item.lineHeight}px;text-align:${
                      item.align
                    };font-family:${item.family};`"
                  >
                    {{ ele[item.FiledKey] }}
                  </div>
                </div>
                <vue-qr
                  :size="item.w"
                  :text="ele[item.FiledKey]"
                  :margin="0"
                  v-else
                ></vue-qr>
              </VueDragResize>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import VueDragResize from 'vue-drag-resize'
import tools from '@/utils/tools.js'
import vueQr from 'vue-qr'
export default {
  data() {
    return {
      title: '',
      loading: false,
      rows: [],
      drawer: false,
      TemplateList: [],
      TemplateId: '',
      TemplateName: '',
      TemplateJson: {},
    }
  },
  props: {},
  components: { VueDragResize, vueQr },
  methods: {
    async generatePdf() {
      console.log(this.$refs.pdfContent.length)
      let Loading = this.$loading({
        lock: true,
        text: '正在生成文件, 请稍后',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let ImgArr = []
      for (let i = 0; i < this.$refs.pdfContent.length; i++) {
        await tools.generateImage(this.$refs.pdfContent[i]).then((res) => {
          ImgArr.push(res)
        })
      }
      this.$http
        .post('/PB/PB_Project/PrintDeviceItem', {
          width: this.TemplateJson.width,
          height: this.TemplateJson.height,
          imgs: ImgArr,
        })
        .then((res) => {
          Loading.close()
          if (res.Success) {
            tools.downloadUrl(res.Data)
          } else {
            this.$notify.error(res.Msg)
          }
        })

      console.log(ImgArr)
      console.log(this.$refs.Content)
    },
    changeTemplate(id) {
      console.log(id)
      let data = this.TemplateList.find((item) => {
        return item.Id == id
      })
      this.TemplateJson = JSON.parse(data.DataJson)
    },
    getTemplateList() {
      this.$http
        .post('/Base_DeviceTreeManage/Device_AssetCardTemplate/GetDataList', {})
        .then((res) => {
          if (res.Success) {
            this.TemplateList = res.Data
          }
        })
    },

    openForm(title, rows = []) {
      this.drawer = true
      this.TemplateId = ''
      this.TemplateName = ''
      this.TemplateJson = {}

      this.getTemplateList()

      this.title = title
      this.rows = rows
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/Base_Manage/Base_User/GetTheData', { id: id })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.form = resJson.Data
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 160px);
  overflow-y: auto;
  box-sizing: border-box;
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.Dom {
  border: 1px solid #e8e8e8;
  margin: 0 auto;
  margin-bottom: 10px;
}
.header {
  height: 60px;
  padding: 0px 10px;
}
</style>
